import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['type', 'embroideryFields', 'screenFields'];

  connect() {
    this.selectType();
  }

  selectType() {
    if (this.typeTarget.value === 'Embroidery') {
      this.embroideryFieldsTarget.classList.remove('d-none');
      this.screenFieldsTarget.classList.add('d-none');
    } else if (this.typeTarget.value === 'Screen') {
      this.screenFieldsTarget.classList.remove('d-none');
      this.embroideryFieldsTarget.classList.add('d-none');
    } else if (this.typeTarget.value === 'Digital') {
      this.screenFieldsTarget.classList.add('d-none');
      this.embroideryFieldsTarget.classList.add('d-none');
    }
  }
}
